export const thresholdDopPolka = 3;

export function addDopPolkaBlock(counter, autoCheck = true) {
    const container = document.querySelector(".dopolnitelnaya_polka__wrap");
    const template = container.querySelector(".dopolnitelnaya_polka__block__1");

    const clone = template.cloneNode(true);
    clone.classList.forEach((cls) => {
        if (cls.startsWith("dopolnitelnaya_polka__block__")) {
            clone.classList.replace(cls, `dopolnitelnaya_polka__block__${counter}`);
        }
    });

    // Обновляем name у input
    clone.querySelectorAll("input").forEach((input) => {
        const oldName = input.getAttribute("name");
        if (oldName) {
            const newName = oldName.replace(/__(\d+)$/, `__${counter}`);
            input.setAttribute("name", newName);
            input.checked = false;
        }
    });

    // Вставляем перед кнопкой
    const addBtn = container.querySelector(".add_dop_polka");
    container.insertBefore(clone, addBtn);

    // Обрабатываем чекбокс
    const dopPolkaInput = clone.querySelector(`input[name="dopolnitelnaya_polka__${counter}"]`);
    if (dopPolkaInput) {
        if (autoCheck) {
            dopPolkaInput.checked = true;
        }
        dopPolkaInput.addEventListener("change", dopPolkaHandler);
        dopPolkaInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
}

function dopPolkaHandler() {
    const servObj = window?.servObj || parent?.servObj;

    // проверяем, есть ли хоть одна активная полка
    const dopPolkaNodeList = document.querySelectorAll(`input[type="checkbox"][name^="dopolnitelnaya_polka__"]`);
    const isAnyChecked = Array.from(dopPolkaNodeList).some((el) => el.checked);

    const addBtn = document.querySelector(".add_dop_polka");
    if (addBtn) {
        const overLimit = (servObj?.counterDopPolka ?? 0) > servObj.thresholdDopPolka;
        addBtn.classList.toggle("disable", !isAnyChecked || overLimit);
    }
}

export function initDopPolkaListeners() {
    const servObj = window.servObj || parent.servObj;
    servObj.counterDopPolka =
        document.querySelectorAll(".dopolnitelnaya_polka__block__1, [class*='dopolnitelnaya_polka__block__']").length +
        1;

    const isTelezhka = servObj.targetPageKey === "telezhki";
    servObj.thresholdDopPolka = isTelezhka ? 2 : thresholdDopPolka;

    const btn = document.querySelector(".add_dop_polka");
    if (!btn) return;

    btn.addEventListener("pointerdown", () => {
        if (servObj.counterDopPolka > servObj.thresholdDopPolka) {
            btn.classList.add("disable");
            return;
        }

        addDopPolkaBlock(servObj.counterDopPolka, true);
        servObj.counterDopPolka++;

        if (servObj.counterDopPolka > servObj.thresholdDopPolka) {
            btn.classList.add("disable");
        }
    });

    const firstInput = document.querySelector("input[name='dopolnitelnaya_polka__1']");
    firstInput.addEventListener("change", dopPolkaHandler);
}

export function resetDopPolkaBlocks() {
    const servObj = window.servObj || parent.servObj;
    const container = document.querySelector(".dopolnitelnaya_polka__wrap");
    if (!container) return;

    // оставляем только первый блок
    const blocks = container.querySelectorAll("[class*='dopolnitelnaya_polka__block__']");
    if (!blocks) return;
    blocks.forEach((block, idx) => {
        if (idx > 0) block.remove();
    });

    servObj.counterDopPolka = 2;

    const btn = container.querySelector(".add_dop_polka");
    btn.classList.remove("disable");
}
